import { Type } from 'io-ts';

export type Phantom<P extends string, T> = T & {__TYPE__?: P};

export const Phantom = <P extends string,T,S>(codecT: Type<T,S>): Type<Phantom<P,T>, Phantom<P,S>> =>
  codecT as Type<Phantom<P,T>, Phantom<P,S>>;
